import React, { FC } from 'react';

import BaseIcon, { IconProps } from './BaseIcon';

export const MAX_STROKE_DASH_OFFSET = 130;

const AdCountdownProgressIcon: FC<IconProps> = props => {
  const { size = 32, strokeDashOffset = 0 } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <BaseIcon {...props} size={size} viewBox="0 0 45 46">
      <circle
        fill="none"
        cx="22.5"
        cy="23"
        r="20.7"
        stroke="white"
        strokeDasharray="130"
        strokeWidth="3.6"
        strokeOpacity="0.2"
        strokeDashoffset="0"
      />
      <circle
        cx="22.5"
        cy="23"
        r="20.7"
        fill="none"
        stroke="white"
        strokeDasharray="130"
        strokeWidth="3.6"
        style={{
          transformOrigin: 'center',
          transform: 'rotate(270deg)',
          transition: 'stroke-dashoffset 0.1s ease 0s',
        }}
        strokeDashoffset={strokeDashOffset}
      />
    </BaseIcon>
  );
};

export default AdCountdownProgressIcon;
